var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',{model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('vs-tab',{attrs:{"label":"Pickup"}},[_c('pickup',{on:{"edit":_vm.edit}})],1),_c('vs-tab',{attrs:{"label":"Form"}},[(!_vm.allowForm)?_c('div'):_c('pickup-form',{attrs:{"do_id":_vm.doId},on:{"close":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }